import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../auth/AuthProvider";
import { getProjectTags } from "../api/portfolio";

export function useProjectTags(projectId: string | undefined) {
  const { token } = useAuth();
  return useQuery<Record<string, string[]>>({
    queryKey: ["project-tags", projectId],
    queryFn: () => getProjectTags(token!, projectId!),
    enabled: !!token && !!projectId,
    staleTime: 1000 * 60 * 5,
  });
}
